import api from './api';

const employeeService = {
  getAllEmployees: async () => {
    try {
      const response = await api.get('/employees');
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar funcionários:', error);
      throw error;
    }
  },

  getEmployee: async (id: number) => {
    try {
      const response = await api.get(`/employees/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar funcionário ${id}:`, error);
      throw error;
    }
  },

  createEmployee: async (employee: any) => {
    try {
      const response = await api.post('/employees', employee);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar funcionário:', error);
      throw error;
    }
  },

  updateEmployee: async (id: number, employee: any) => {
    try {
      const response = await api.put(`/employees/${id}`, employee);
      return response.data;
    } catch (error) {
      console.error(`Erro ao atualizar funcionário ${id}:`, error);
      throw error;
    }
  },

  deleteEmployee: async (id: number) => {
    try {
      const response = await api.delete(`/employees/${id}`);
      return response.status;
    } catch (error) {
      console.error(`Erro ao excluir funcionário ${id}:`, error);
      throw error;
    }
  },
};

export default employeeService;